import { lazy } from "react";
import { Route } from "react-router-dom";
import { AppRoutes } from "@/infra/router";
import LazyPage from "@/infra/router/LazyPage";

const OnboardingBaseLayout = lazy(() => import("@/components/onboarding/OnboardingBaseLayout"));
const StartOnboardingPage = lazy(() => import("./StartOnboardingPage"));
const OnboardingInvitationCodePage = lazy(() => import("./OnboardingInvitationCodePage"));
const OnboardingTermsAndConditions = lazy(() => import("./OnboardingTermsAndConditions"));
const VerificationPage = lazy(() => import("./OnboardingVerificationPage"));

const OnboardingRevokedInvitation = lazy(() => import("./OnboardingRevokedInvitation"));
const OnboardingErrorPage = lazy(() => import("./OnboardingErrorPage"));

export const GUEST_ONBOARDING_ROUTES = (
  <>
    <Route
      aria-describedby="landing-page"
      path={AppRoutes.Onboarding}
      element={<LazyPage element={<StartOnboardingPage />} />}
    />
    <Route path={AppRoutes.Onboarding} element={<LazyPage element={<OnboardingBaseLayout />} />}>
      <Route
        aria-describedby="onboarding-step-1"
        key={AppRoutes.OnboardingInvitationCode}
        path={AppRoutes.OnboardingInvitationCode}
        element={<LazyPage element={<OnboardingInvitationCodePage />} />}
      />
      {/* onboarding-step-2 is Auth0 password setup page */}
      <Route
        aria-describedby="onboarding-error-revoked"
        path={AppRoutes.RevokedInvitation}
        element={<LazyPage element={<OnboardingRevokedInvitation />} />}
      />
      <Route
        aria-describedby="onboarding-error-unknown"
        key={AppRoutes.OnboardingError}
        path={AppRoutes.OnboardingError}
        element={<LazyPage element={<OnboardingErrorPage />} />}
      />
    </Route>
  </>
);

export const PROTECTED_ONBOARDING_ROUTES = (
  <>
    <Route
      aria-describedby="onboarding-signup-verification"
      element={<LazyPage element={<VerificationPage />} />}
      path={AppRoutes.OnboardingVerify}
      key={AppRoutes.OnboardingVerify}
    />
    <Route path={AppRoutes.Onboarding} element={<LazyPage element={<OnboardingBaseLayout />} />}>
      <Route
        aria-describedby="onboarding-step-3"
        key={AppRoutes.OnboardingTermsAndConditions}
        path={AppRoutes.OnboardingTermsAndConditions}
        element={<LazyPage element={<OnboardingTermsAndConditions />} />}
      />
    </Route>
  </>
);
